import config from "../config/config";
import { commonConstants, proConstants } from "../constants/pro";

export const setUserDetails = user => {
  const { authorize_token, mainUserToken, lastURL } = user;
  if (authorize_token) {
    localStorage.setItem("token", authorize_token);
  }
  if (mainUserToken) {
    localStorage.setItem("mainUserToken", mainUserToken);
  }
  if (lastURL) {
    localStorage.setItem("lastURL", lastURL);
  }
  if (user.completed_steps !== undefined) {
    localStorage.setItem("completedSteps", user.completed_steps);
  }
};

export const updateCompletedSteps = (completedSteps) => {
  let currrentCompletedSteps = (parseInt)(localStorage.getItem("completedSteps"));
  if(currrentCompletedSteps === proConstants.ALL_COMPLETED_STEPS){
    return true;
  }
  completedSteps = completedSteps + 1;
  if(completedSteps > proConstants.BILLING_COMPLETED_STEPS) { //last page of completed steps
    completedSteps = proConstants.ALL_COMPLETED_STEPS;
  }
  localStorage.setItem("completedSteps", completedSteps);
};

export const isRedirectPage = () => {
  return ((parseInt)(localStorage.getItem("completedSteps")) !== proConstants.ALL_COMPLETED_STEPS);
};

export const getUserToken = () => {
  return localStorage.getItem("token");
};

export const removeUserDetails = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("mainUserToken");
  localStorage.removeItem("completedSteps");
};

export const getMainUserToken = () => {
  return localStorage.getItem("mainUserToken") || "";
};

export const setBackMainUserToken = () => {
  const mainToken = getMainUserToken();
  setUserDetails({ authorize_token: mainToken });
  localStorage.removeItem("mainUserToken");
};

export const getRequestHeaders = () => {
  let headers = {
    "x-client-version": config.appVersion,
    "x-api-key": config.APIKEY,
    "x-device-type": getDeviceType(),
    "x-uuid": getUDID(),
    //"Content-Type": "application/json",
    //"Content-Type": 'multipart/form-data',
    "x-authorize-token": getUserToken(),
    //"x-authorize-token-main": getMainUserToken(),
  };

  return headers;
};

export const getUrlPermissions = requestedUrlPath => {
  let urlPermissions = [];

  if (requestedUrlPath && commonConstants.accessPaths) {
    const matchedUrl = Object.keys(commonConstants.accessPaths).filter(key => {
      const reg = new RegExp(key);
      return reg.test(requestedUrlPath);
    });

    matchedUrl.forEach(data => {
      commonConstants.accessPaths[data] &&
        urlPermissions.push(...commonConstants.accessPaths[data]);
    });
  }

  return urlPermissions;
};

//#region Helper functions
function getUDID() {
  return window.navigator.userAgent.replace(/\D+/g, "");
}

function getDeviceType() {
  /* var Sys = {};
  var ua = navigator.userAgent.toLowerCase();
  var s;
  (s = ua.match(/msie ([\d.]+)/))
    ? (Sys.ie = s[1])
    : (s = ua.match(/firefox\/([\d.]+)/))
    ? (Sys.firefox = s[1])
    : (s = ua.match(/chrome\/([\d.]+)/))
    ? (Sys.chrome = s[1])
    : (s = ua.match(/opera.([\d.]+)/))
    ? (Sys.opera = s[1])
    : (s = ua.match(/version\/([\d.]+).*safari/))
    ? (Sys.safari = s[1])
    : 0;

  if (Sys.ie) return "IE: " + Sys.ie;
  if (Sys.firefox) return "Firefox: " + Sys.firefox;
  if (Sys.chrome) return "Chrome: " + Sys.chrome;
  if (Sys.opera) return "Opera: " + Sys.opera;
  if (Sys.safari) return "Safari: " + Sys.safari; */

  return "1";
}

export function formatPhoneNumber(phoneNumberString) {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }
  return "";
}
//#endregion
